import { openModal } from '@core/components/ModalStack';
import { ChangeHistoryModalProps } from './ChangeHistoryModal';

export async function openChangeHistoryModal(props: ChangeHistoryModalProps) {
  const { ChangeHistoryModal } = await import('./ChangeHistoryModal');

  openModal(ChangeHistoryModal, props);
}
